export default function bookingRedirect() {
  const redirectIntoBooking = (
    baseUrl,
    movieId = '',
    cinemaId = '',
    date = '',
    screen = ''
  ) => {
    const m = movieId ? `movieId=${movieId}` : ''
    const c = cinemaId ? `cinemaId=${cinemaId}` : ''
    const d = date ? `date=${date}` : ''
    const s = screen ? `screen=${screen}` : ''

    const setupQuery = [m, c, d, s].filter((n) => n).join('&')

    window.location.href = `${baseUrl}?${setupQuery}`
  }

  return {
    redirectIntoBooking,
  }
}
